import React from 'react';
import PropTypes from 'prop-types';

class Filepicker extends React.Component {
  constructor(props) {
    super(props);

    this.handleFileSelectionChange = this.handleFileSelectionChange.bind(this);
  }

  handleFileSelectionChange() {
    this.props.onChange([...this.fileInputRef.files]);
  }

  render() {
    const { children, ...restOfProps } = this.props;

    return (
      <div className="file-picker-wrapper">
        <input
          {...restOfProps}
          type="file"
          ref={node => {
            this.fileInputRef = node;
          }}
          onChange={this.handleFileSelectionChange}
        />
        {children}
      </div>
    );
  }
}

Filepicker.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Filepicker;
